import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';
import { earlyLoanRepayment } from './configByFeature/earlyLoanRepayment/base';

export const loans: LoanFeatureConfig = {
    defaultRoute: 'overview',
    productConfig: {
        preformattedAccountNumber: false,
    },
    dashboard: {
        showInstallmentFrequency: false,
        showOutstandingDebt: false,
    },
    overview: {
        enabled: false,
        showTransactions: false,
        showAdditionalInfo: false,
        latestTransactionCount: 5,
        showEarlyLoanRepaymentActionButton: false,
        showLoanDisclaimer: false,
        showLoanAmountHighlightRow: false,
        showLinkedAccount: false,
        showLoanCurrency: false,
        showExtraInstallment: false,
        displayDedicatedMortgageInfos: false,
    },
    additionalDetails: {
        showOverdueInfo: false,
        showExtraInstallment: false,
        lastInstallment: {
            showInstallmentFrequency: false,
        },
    },
    transactions: {
        enabled: false,
        mode: 'always',
    },
    statements: {
        enabled: false,
        mode: 'always',
        deliveryDefinitions: {
            distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
            format: ['PDF_A4'],
            periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
            canCreateDefinition: false,
            channelEditable: false,
            statementNumberEditable: false,
        },
        showMultiDownloadCard: false,
        showNewCustomStatementCard: false,
        showDeliveryDefinitions: false,
        showDownloadOptions: false,
    },
    settingsDetails: {
        displayAccountOwner: false,
        displayIban: false,
        displaySlashedBBAN: false,
        displayPlainAccountNumber: false,
        displayBIC: false,
        displayLoanIdentifier: false,
        displaySpacedBBAN: false,
    },
    earlyLoanRepayment,
    layout: {
        productInfo: {
            formatAccountNumber: false,
        },
    },
};
